import React from "react";
import { Stack, Typography } from "@mui/material";
import { birthDateFormatter, dateFormatter, maskPhone } from "../../utils/masking";

interface Customer {
  email?: string;
  mobilePhoneNumber?: string;
  optInEmail?: boolean;
  optInSms?: boolean;
  birthDate?: string;
  birthdayUpdated?: boolean;
  hasAcceptedTerms?: boolean;
  termsAcceptedDate?: string;
}

interface ContactInfoProps {
  customer: Customer;
}

export const ContactInfo = ({ customer }: ContactInfoProps) => {
  const renderInfoRow = (label: string, value: string | undefined, formatter?: (val: string) => string) => {
    let displayValue = `No ${label}`;
    if (value) {
      displayValue = formatter ? formatter(value) : value;
    }
    
    return (
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="body2" fontWeight={600}>{label}:</Typography>
        <Typography variant="body2">{displayValue}</Typography>
      </Stack>
    );
  };

  const renderBooleanRow = (label: string, value: boolean | undefined) => (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="body2" fontWeight={600}>{label}:</Typography>
      <Typography variant="body2">{value ? "Yes" : "No"}</Typography>
    </Stack>
  );

  return (
    <Stack spacing={1}>
      {renderInfoRow("Email", customer.email)}
      {renderInfoRow("Phone", customer.mobilePhoneNumber, maskPhone)}
      {renderBooleanRow("Email Opt-in", customer.optInEmail)}
      {renderBooleanRow("SMS Opt-in", customer.optInSms)}
      {renderInfoRow("Birthday", customer.birthDate, birthDateFormatter)}
      {renderBooleanRow("Birthday Updated", customer.birthdayUpdated)}
      {renderBooleanRow("Has Accepted Terms", customer.hasAcceptedTerms)}
      {renderInfoRow("Terms Accepted Date", customer.termsAcceptedDate, dateFormatter)}
    </Stack>
  );
};
